import { Container, Form, Navbar } from "react-bootstrap";
import logo from "../images/logo.png";
import { useDispatch } from "react-redux";
import { searchingFunction } from "../Redux/actions";
const NavBar = () => {
  const dispatch = useDispatch();

  return (
    <div>
      <Navbar expand="lg" className="bg-color">
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} className="img-title" alt="img" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll" className="mt-2">
            <Form
              className="d-flex align-items-center w-100"
              style={{ position: "relative" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  zIndex: 2,
                  transform: "translateY(-50%)",
                }}
                viewBox="0 0 16 16"
              >
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
              </svg>
              <Form.Control
                type="search"
                className="me-2 p-3 ps-5 search position-relative rounded-pill"
                aria-label="Search"
                onChange={(e) => dispatch(searchingFunction(e.target.value))}
                placeholder="بحث"
              />
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavBar;
